import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDateComparisonExpressionBehavior } from "../../../../documaker/domain/format/objects";

export interface IDateComparisonExpressionBehaviorPropertyEditable {
  dateComparisonExpressionBehavior(): IPropertyEditable<IDateComparisonExpressionBehavior>;
}

export function instanceOfIDateComparisonExpressionBehaviorPropertyEditable(instance: any): instance is IDateComparisonExpressionBehaviorPropertyEditable {
  return instance
    && instance.dateComparisonExpressionBehavior
    && instanceOfIPropertyEditable<IDateComparisonExpressionBehavior>(instance.dateComparisonExpressionBehavior());
}
